import discoveryImg from "../img/caseStudies/DSYEpilogThumbnail.svg";
import dukeImg from "../img/caseStudies/DukeUniversityHospital.svg";
import dsyCaseStudy from "../img/caseStudies/dsyCaseStudy.png";
import dukeCaseStudy from "../img/caseStudies/dukeCaseStudy.png";

const caseStudiesData = [
    {
        title: 'Giving access to home based care at the right time',
        description: 'In collaboration with South Africa\'s largest Health Insurer, Epilog continuously engages complex, high-need patients helping 48% transition to the most appropriate care at the right time ',
        img: discoveryImg,
        caseStudyImg: dsyCaseStudy,
    },
    {
        title: 'A Digital Conversational AI Platform to Extend Outpatient Palliative Care',
        description: 'In collaboration with Duke University Hospital, Epilog moves care for patients with serious, complex conditions from episodic to continuous, enhancing engagement and efficacy between visits.',
        img: dukeImg,
        caseStudyImg: dukeCaseStudy,
    },
];

export default caseStudiesData;
